import { BookingCharge } from 'generated/graphql'

export const hasMeaningfulChargeData = (charge?: Partial<BookingCharge> | null): boolean => {
  if (!charge) {
    return false
  }

  const numericId = Number(charge.id)
  const hasId = Number.isInteger(numericId) && numericId > 0
  const hasName = charge.name !== null && charge.name !== undefined && charge.name.trim().length > 0
  const hasType = charge.type !== null && charge.type !== undefined

  // Some copy flows can return metadata-only rows. Keep rows that are persisted or have real payload.
  return hasId || (hasName && hasType)
}

export const getVisibleCharges = (charges?: BookingCharge[]): BookingCharge[] =>
  charges?.filter((c) => !c.isDeleted && hasMeaningfulChargeData(c)) ?? []

export const getNonAutomaticCharges = (charges?: BookingCharge[]): BookingCharge[] =>
  getVisibleCharges(charges).filter((c) => !c.isAutomatic)
